// src/components/Common/LoadingSpinner.jsx
import React from "react";

export default function LoadingSpinner({ type = "page" }) {
  if (type === "card") {
    // ✅ Use this version for small sections like blog cards or team cards
    return (
      <div className="w-full h-[180px] bg-gray-100 animate-pulse rounded-lg" />
    );
  }

  // ✅ Default full-page shimmer loader (for Suspense fallback)
  return (
    <div className="flex flex-col items-center justify-center w-full min-h-[60vh] px-6">
      {/* 🔹 Shimmer header */}
      <div className="w-2/3 h-6 bg-gray-200 rounded-md animate-shimmer mb-6" />

      {/* 🔹 Shimmer paragraph lines */}
      <div className="w-full max-w-2xl space-y-3">
        <div className="w-full h-4 bg-gray-200 rounded-md animate-shimmer" />
        <div className="w-5/6 h-4 bg-gray-200 rounded-md animate-shimmer" />
        <div className="w-3/4 h-4 bg-gray-200 rounded-md animate-shimmer" />
      </div>

      {/* 🔹 Optional placeholder blocks */}
      <div className="w-full max-w-6xl grid grid-cols-3 gap-5 mt-10">
        {Array(3)
          .fill()
          .map((_, i) => (
            <div
              key={i}
              className="w-full h-[160px] bg-gray-200 rounded-lg animate-shimmer"
            />
          ))}
      </div>
    </div>
  );
}
